
import { getLayer, getLayers } from '../reducers';
import { getActions } from '../sagas';

/**
 * Command `map.setLayerVisibility`
 *
 * @typedef {Object} MultSceneForApp~Map~Commands~SetLayerVisibility
 * @property {string} command - name of command, has value `map.setLayerVisibility`
 * @property {String} id - ID of layer
 * @property {Boolean} visibility - visibility of layer
 */
function setLayerVisibility(params, dispatch, store) {

    let layer = getLayer(store.getState().map.map, params.id);
    let layers = getLayers(store.getState().map.map);
    const setLayerVisibility = getActions(dispatch).setLayerVisibility;

    if (layer.base && params.visibility) {
        let previousVisibleBaseLayer = layers.reduce((previous, current) => {
            return (current.base && current.visible)
                ? current
                : previous;
        }, null);
        if (previousVisibleBaseLayer) {
            setLayerVisibility(previousVisibleBaseLayer.id, false);
            setLayerVisibility(params.id, true);
        }
    } else {
        setLayerVisibility(params.id, params.visibility);
    }
}

export default {
    name: 'map.setLayerVisibility',
    execute: setLayerVisibility
}
